// Runs on the client before hydration (Next.js client instrumentation).
//
// The React #185 "Maximum update depth exceeded" crash originates outside the
// assistant message error boundary (in the auth-gated chat-history/sidebar
// path) and is therefore uncaught — React reports it via window "error". We
// capture it here and POST it to the server so it appears in prod logs with a
// stack (de-minifiable via the production source maps), instead of only as a
// minified console error no one sees.

const REPORT_ENDPOINT = "/api/client-error";
const MAX_REPORTS = 20;
let reportCount = 0;

function reportClientError(payload: Record<string, unknown>) {
  if (reportCount >= MAX_REPORTS) {
    return;
  }
  reportCount += 1;

  try {
    const body = JSON.stringify({ ...payload, reportedAt: new Date().toISOString() });

    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon(REPORT_ENDPOINT, new Blob([body], { type: "application/json" }));
      return;
    }

    void fetch(REPORT_ENDPOINT, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body,
      keepalive: true,
    });
  } catch {
    // Never let error reporting throw.
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    reportClientError({
      kind: "error",
      message: event.message,
      stack: event.error instanceof Error ? event.error.stack : null,
      source: event.filename,
      line: event.lineno,
      column: event.colno,
      url: window.location.href,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    reportClientError({
      kind: "unhandledrejection",
      message: reason instanceof Error ? reason.message : String(reason),
      stack: reason instanceof Error ? reason.stack : null,
      url: window.location.href,
    });
  });
}
